module.exports = __webpack_public_path__ + "img/restapi.b15ed678.svg";